export default {
  //get all TAGs
  GET_SUPERADMIN_TAGS_REQUEST: "GET_SUPERADMIN_TAGS_REQUEST",
  GET_SUPERADMIN_TAGS_SUCCESS: "GET_SUPERADMIN_TAGS_SUCCESS",
  GET_SUPERADMIN_TAGS_FAIL: "GET_SUPERADMIN_TAGS_FAIL",

  //edit TAGs
  EDIT_SUPERADMIN_TAG_REQUEST: "EDIT_SUPERADMIN_TAG_REQUEST",
  EDIT_SUPERADMIN_TAG_SUCCESS: "EDIT_SUPERADMIN_TAG_SUCCESS",
  EDIT_SUPERADMIN_TAG_FAIL: "EDIT_SUPERADMIN_TAG_FAIL",

  //create TAG
  CREATE_SUPERADMIN_TAG_REQUEST: "CREATE_SUPERADMIN_TAG_REQUEST",
  CREATE_SUPERADMIN_TAG_SUCCESS: "CREATE_SUPERADMIN_TAG_SUCCESS",
  CREATE_SUPERADMIN_TAG_FAIL: "CREATE_SUPERADMIN_TAG_FAIL",

  DELETE_SUPERADMIN_TAG_REQUEST: "DELETE_SUPERADMIN_TAG_REQUEST",
  DELETE_SUPERADMIN_TAG_SUCCESS: "DELETE_SUPERADMIN_TAG_SUCCESS",
  DELETE_SUPERADMIN_TAG_FAIL: "DELETE_SUPERADMIN_TAG_FAIL",

  GET_SUPERADMIN_TAG_REQUEST: "GET_SUPERADMIN_TAG_REQUEST",
  GET_SUPERADMIN_TAG_SUCCESS: "GET_SUPERADMIN_TAG_SUCCESS",
  GET_SUPERADMIN_TAG_FAIL: "GET_SUPERADMIN_TAG_FAIL",

  ENABLE_SUPERADMIN_TAG_REQUEST: "ENABLE_SUPERADMIN_TAG_REQUEST",
  ENABLE_SUPERADMIN_TAG_SUCCESS: "ENABLE_SUPERADMIN_TAG_SUCCESS",
  ENABLE_SUPERADMIN_TAG_FAIL: "ENABLE_SUPERADMIN_TAG_FAIL",
  //loading
  ADD_SUPERADMIN_TAGS_LOADING: "ADD_SUPERADMIN_TAGS_LOADING",
};
